const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 6,
    position: "absolute",
    pointerEvents: "auto",
    left: 0,
    top: 5,
    maxWidth: "90%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ComponentHeader,
    width: 435,
    maxHeight: "87%",
    "& $disableIcon": {
      cursor: "not-allowed",
      opacity: 0.5,
      pointerEvents: "all",
      color: theme.iconColor,
    },
  },
  backButtonSize: {
    fontSize: 24,
    color: theme.iconColor,
  },
  refreshButton: {
    position: "absolute",
    right: "28px",
    color: theme.iconColor,
  },
  refreshButtonSize: {
    fontSize: 24,
    color: theme.iconColor,
  },
  headerIcon: {
    fontSize: 18,
    color: theme.iconColor,
    pointerEvents: "all",
  },
  activeHeaderIcon: {
    fontSize: 18,
    color: theme.palette.primary.main,
    pointerEvents: "all",
  },
  driverNumber: {
    fontSize: theme.textFontSize,
    color: theme.gridTextColor,
    padding: 12,
    minWidth: 55
  },
  driverStatusContainer: {
    display: "flex",
    alignItems: "center",
  },
  driverLoggedInIcon: {
    color: theme.palette.primary.main,
    fontSize: 18,
  },
  driverLoggedOutIcon: {
    color: theme.rowViolationDotColor,
    fontSize: 18,
  },
  cardsContainer: {
    padding: 8,
    border: `1px solid ${theme.AppBGColor}`,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflowY: "auto",
  },
  card: {
    marginBottom: 3,
    background: 'transparent',
    "& $enableIcon,& $editIcon,& $lockIcon": {
      "&$disableIcon": {
        cursor: "not-allowed",
        opacity: 0.5,
        pointerEvents: "all",
        color: theme.iconColor,
      },
    },
  },
  driverPopupCardHeaderIcon:{
    padding: 8
  },
  footer: {
    lineHeight: 2,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    opacity: 0.9,
    padding: 8,
    display: "flex",
  },
  disableIcon: {
    cursor: "not-allowed",
    opacity: 0.7,
    pointerEvents: "all",
  },

  enableIcon: {
    cursor: "pointer",
  },
  editIcon: {
    marginTop: 8,
    color: theme.iconColor,
  },
  lockIcon: {
    fontSize: "1rem",
    color: theme.iconColor,
    marginTop: 5,
    opacity: 0.6,
  },

  titlePending: {
    fontSize: theme.textFontSize,
    color: theme.ToggleIconColor,
  },
  titleReturnOrException: {
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize,
  },
  titleCompleted: {
    color: theme.completeStopText,
    fontSize: theme.textFontSize,
  },
  subheaderPending: {
    color: theme.ModalHeaderTextColor,
    fontSize: theme.dispatchCardTextFontSize,
  },
  subheaderReturnOrException: {
    color: theme.ErrorMessageColor,
    fontSize: theme.dispatchCardTextFontSize,
  },
  subheaderCompleted: {
    color: theme.completeStopText,
    fontSize: theme.dispatchCardTextFontSize,
  },
  avatarPending: {
    color: theme.ToggleIconColor,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.ToggleIconColor}`,
    width: 28,
    height: 28,
    fontSize: theme.headerTextFontSize,
  },
  avatarReturnOrException: {
    color: theme.ErrorMessageColor,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.ErrorMessageColor}`,
    width: 28,
    height: 28,
    fontSize: theme.headerTextFontSize,
  },
  avatarCompleted: {
    color: theme.completeStopText,
    backgroundColor: theme.ComponentHeader,
    border: `1px solid ${theme.completeStopText}`,
    width: 28,
    height: 28,
    fontSize: theme.headerTextFontSize,
  },
  pickupStopAvatar: {
    borderRadius: "3px",
  },
  headerRoot: {
    padding: 8,
    backgroundColor: theme.ModalBGColor,
  },
  collapsibleDetailsRoot: {
    padding: 4,
    backgroundColor: theme.ModalBGColor,
    '&:last-child':{
      padding:4,
      paddingBottom : 8
    }
  },
  cardContentStatusWrapper: {
    padding: 0,
  },
  statusWrapperPending: {
    backgroundColor: theme.StatusWrapperColor,
    height: 24,
    display: "flex",
    justifyContent: "space-between",
  },
  statusWrapperReturnOrException: {
    backgroundColor: theme.statusWrapperHighlightedColor,
    height: 24,
    display: "flex",
    justifyContent: "space-between",
  },
  statusWrapperCompleted: {
    backgroundColor: theme.stopListCardStatusBar,
    height: 24,
    display: "flex",
    justifyContent: "space-between",
  },
  status: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  stopStatusPending: {
    fontSize: theme.textFontSize,
    color: theme.ToggleIconColor,
    lineHeight: 2,
    marginLeft: 8,
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  stopStatusReturnOrException: {
    fontSize: theme.textFontSize,
    color: theme.ErrorMessageColor,
    lineHeight: 2,
    marginLeft: 8,
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  stopStatusCompleted: {
    fontSize: theme.textFontSize,
    color: theme.completeStopText,
    lineHeight: 2,
    marginLeft: 8,
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  statusTimePending: {
    color: theme.ToggleIconColor,
    lineHeight: 2,
    float: "right",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  statusTimeReturnOrException: {
    color: theme.ErrorMessageColor,
    lineHeight: 2,
    float: "right",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  statusTimeCompleted: {
    color: theme.completeStopText,
    lineHeight: 2,
    float: "right",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  priorityPending: {
    color: theme.ToggleIconColor,
    lineHeight: 2,
    fontWeight: "bold",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  priorityReturnOrException: {
    color: theme.ErrorMessageColor,
    lineHeight: 2,
    fontWeight: "bold",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  priorityCompleted: {
    color: theme.completeStopText,
    lineHeight: 2,
    fontWeight: "bold",
    marginRight: 8,
    fontSize: theme.textFontSize,
  },
  priorityContainer: {
    marginRight: 12,
  },
  statusCodeContainer: {
    display: "flex",
    justifyContent: "flex-end",
    flexShrink: 0,
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
    fontWeight: 600,
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
  },
  stopSequenceIcon: {
    marginLeft: 4,
    marginRight: 4
  },
  statusCode: {
    marginRight: 8,
    maxWidth: 100,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  completeColor: {
    color: theme.completeStopText,
  },
  stopColor: {
    color: theme.ToggleIconColor,
  },
  expand: {
    backgroundColor: theme.ModalBGColor,
    color: theme.iconColor,
    borderRadius: 0,
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  recommendationContainer: {
    backgroundColor: theme.ModalBGColor,
    height: "101px",
    margin: 1,
    marginBottom: "5px",
  },
  headerContainer: {
    borderBottom: `1px solid ${theme.AppBGColor}`,
    minHeight: "46px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  routeIcon: {
    width: "15px",
    height: "50%",
    position: "absolute",
    top: "27%",
    left: "4%",
  },
  detailsContainer: { display: "flex", alignItems: "center" , width:"50%"},
  driverNameContainer:{maxWidth:"80%"},
  driverName: {
    color: theme.HeaderSelectedText,
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%",
  },
  driverPhoneNo: {
    fontSize: "10px",
    fontWeight: 600,
    color: theme.ModalHeaderTextColor,
  },
  upperEnrouteToValue: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    color: theme.gridTextColor,
  },
  lowerDetails: {
    paddingBottom: 4,
    marginBottom: 8,
    marginLeft: 4,
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflowY: "auto",
    maxHeight: 230,
    minHeight: "20vh"
  },
  expandedLowerDetails: {
    minHeight: "25vh"
  },
  contentContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    overflow: "hidden",
  },
  tableHeaderCell: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.ModalHeaderTextColor,
    fontWeight: 400,
    padding: 0,
    paddingLeft: "14px",
    paddingTop: "8px",
    border: "none",
    width: 72,
  },
  proDetailsHeaderCell: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.ModalHeaderTextColor,
    fontWeight: 400,
    padding: 0,
    paddingLeft: "14px",
    paddingTop: "8px",
    border: "none",
    minWidth: 100,
  },
  tableDataCell: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    border: "none",
    color: theme.gridTextColor,
  },
  routeDetails:{
    '& $tableDataCell':{
      minWidth:110
    }
  },
  proDetailsDataCell: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    border: "none",
    color: theme.gridTextColor,
    width: "100%",
  },
  proDetailsContainer: {
    display: "flex",
    flexDirection: "column",
  },
  detailSection:{
    display: "flex",
    flexDirection: "row",
  }, 
  tableRow: {
    height: "18px",
  },

  enrouteTo: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    border: "none",
    color: theme.gridTextColor,
    width: "90px",
  },
  missedStops: {
    color: theme.error,
  },
  loader: {
    alignSelf: "center",
  },
  noPadding: { padding: "0px !important" },
  closedWrapper: {
    width: "auto",
    top: -30,
    minWidth: 300,
    transform: "rotate(90deg)",
    transformOrigin: "bottom left",
  },
  collapsedStopsStatus: {
    justifyContent: "space-between",
    paddingLeft: 16,
    textTransform: "uppercase",
  },
  expandIcon: {
    fontSize: 24,
  },
  arrivalTime: {
    fontWeight: 600,
  },
  reactSelect: {
    "& .select__control": {
      minWidth: 118,
      minHeight: 24,
      maxHeight: 24,
      marginTop: 6,
    }
  },
  driverListDropdown: {
    display: "flex",
  },
  footerAction: {
    display: "flex",
    justifyContent: "flex-end",
  },
  footerSpace: {
    width: 8,
    padding: 8,
  },
  actionButton: {
    padding: "4px 8px",
    fontSize: "0.75rem",
    lineHeight: "1.25rem",
  },
  actionButtonText: {
    fontSize: "1rem",
    lineHeight: "1.25rem",
  },
  saveButton: {
    minWidth: 100,
  },
  progressIcon: {
    color: theme.white,
  },
  cancelButton: {
    color: theme.gridTextColor,
    borderColor: theme.gridTextColor,
    "&$cancelButtonDisabled": {
      color: theme.gridTextColor,
      borderColor: theme.gridTextColor,
      opacity: 0.7,
    },
  },
  cancelButtonDisabled: {
    color: "initial",
  },
  dialogContent: {
    maxWidth: 300,
  },
  menu: {
    background: theme.ModalBGColor,
    borderRadius: "0px 0px 4px 4px",
  },
  menuItem: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "14px",
    color: theme.TextColor,
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  },
  infoIcon: {
    marginLeft: 8,
  },
  markNextStopAction: {
    display: "flex",
  },
  stopIconStyles: {
    height: "32px",
    width: "32px",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    borderRadius: "50px",
    cursor: "pointer",
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
  },
  gateInOut: {
    fontWeight: 500,
    fontSize: theme.textFontSize,
    lineHeight: "19px",
    letterSpacing: "-0.02em",
    color: theme.ModalHeaderTextColor,
    marginLeft: 2,
  },
  excessiveLength: {
    width: "fit-content",
    marginTop: 12,
    marginLeft: 2,
    display: "inline-flex",
    paddingRight : 4
  },
  stopStatusContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 0,
    flex: 1,
  },
  overallStopStatusLine: {
    margin: 0,
    display: "flex",
    alignItems: "center",
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  },
  overallStopStatusText: {
    display: "block",
    flex: 1,
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  uaIcon:{
    marginRight: 10
  },
  clickable : {
    textDecoration : "underline",
    color: theme.actionableTextColor,
  },
  driverDetailsContainer: { 
    display: "flex", 
    alignItems: "center", 
    width:"50%",
    justifyContent: "flex-end"
  },
  imageButton: {
    padding: 0,
    color : theme.actionableTextColor,
  },
});

export default styles;
